<template>
<div>
    <div class="d-flex justify-space-between align-center pb-2">
        <div class="important px-1">Users</div>
        <v-btn class="mx-1" outlined color="primary" @click="user_dialog=true" style="height: 30px">
            <span v-if="$vuetify.breakpoint.smAndUp">Add User</span>
            <v-layout v-else row fill-height align-center>
                <v-icon>add</v-icon>
                <div>User</div>
            </v-layout>
        </v-btn>
    </div>

    <v-card class="pa-2" width="100%">

        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search existent users by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon v-if="$vuetify.breakpoint.smAndDown" class="px-1" medium @click="dialog_mobile_sort = true">swap_vert</v-icon>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn v-for="field in search_fields" :key="field.value" smal rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize caption">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->
        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header class="mt-2" :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat class="mx-1">
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <v-row no-gutters align="center">
                            <im-user-item :item="item" style="width: 95%" />
                            <v-icon color="red" @click="openRemoveUser(item)">delete</v-icon>
                        </v-row>
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
    </v-card>


    <!-- user dialog -->
    <v-dialog v-model="user_dialog" max-width="640px">
        <v-card color="secondary">
            <v-card-title primary-title class="primary white--text">
                Add user
            </v-card-title>
            <v-card-text class="pt-3">
                <v-row no-gutters>
                    <v-col cols="12" class="py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Select user to add</div>
                            <im-search-users ref="add_user" class="im-select pa-0 ma-0" @input="selectUser($event)" />
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters class="pt-2 im-search">
                    <v-col cols="12" class="py-1">
                        <v-text-field label="Name" v-model="user.full_name" readonly hide-details />
                    </v-col>
                    <v-col cols="12" class="py-1">
                        <v-text-field label="Email" v-model="user.email" readonly hide-details />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="exitAddUser()">Cancel</v-btn>
                <v-btn color="primary" :disabled="!user.id" @click="addUser(user)">Add User</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./user dialog -->

    <!-- delete user dialog -->
    <v-dialog v-model="remove_user_dialog" max-width="320px" persistent>
        <v-card>
            <v-card-text class="pt-2">
                Are you sure you want to remove the user from organization?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="remove_user_dialog=false">Cancel</v-btn>
                <v-btn dark color="red" @click="removeUser()">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./delete user dialog -->

    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">
                Sort Items by
            </v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_mobile_sort = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";
import SearchUsers from "../../utils/UserSearch.vue";
import IMSortField from "../../utils/IMSortField.vue";
import IMTableHeader from '../../utils/IMTableHeader.vue';
import IMUserItem from '../UserCard.vue';

export default {
    props: {
        organization_id: [Number, String],
    },
    components: {
        'im-search-users': SearchUsers,
        'im-sort-filed': IMSortField,
        'im-table-header': IMTableHeader,
        'im-user-item': IMUserItem,
    },
    data() {
        return {
            // test values
            user: this.$clone(defaults.user_item),

            child: {},
            remove_user_dialog: false,
            user_dialog: false,
            dialog_mobile_sort: false,

            // role table and search
            search: null,
            search_fields: [
                {
                    text: 'ID',
                    value: 'user_id',
                    selected: true
                }, {
                    text: 'First Name',
                    value: 'first_name',
                    selected: true
                }, {
                    text: 'Last Name',
                    value: 'last_name',
                    selected: true
                }, {
                    text: 'Email',
                    value: 'email',
                    selected: false
                }
            ],
            search_timeout: 500,
            items: [],
            loading: false,
            total: 0,
            page: 1,
            size: 5,
            itemsPerPageOptions: [5, 10, 25, 50],

            im_header: [{
                    text: "Name",
                    width: "25%",
                    sortable: true,
                    sort_order: 'first_name',
                    sort_dir: null,
                }, {
                    text: "Organization",
                    width: "25%",
                    sortable: false,

                }, {
                    text: "Contact",
                    width: "31.4%",
                    sortable: false,
                }, {
                    text: "Created at",
                    width: "16.6%",
                    sortable: true,
                    sort_order: 'created_at',
                    sort_dir: null,
                },
            ],
        }
    },

    watch: {
        organization_id: {
            handler() {
                this.getItems();
            }
        },
        page: {
            handler() {
                this.getItems();
            }
        },
        size: {
            handler() {
                this.getItems();
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500);
            }
        }
    },

    created() {
        this.getItems();
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        // users functions
        selectUser(user) {
            if(user) {
                this.user = this.$clone(user);
            } else {
                this.user = this.$clone(defaults.user_item)
            }
        },

        exitAddUser() {
            this.$refs.add_user.clear();
            this.user_dialog = false;
        },

        getItems() {
            if(!this.organization_id) {
                return
            }
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            let organization_ids = [this.organization_id];
            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/users";

            // setup query params
            let params = {
                params: {
                    search: search,
                    organization_ids: organization_ids,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    dir: dirs,
                    stamp: stamp
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    // if the current stamp matches the received stamp, populate items
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        addUser(user) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/users";

            user.organization_id = this.organization_id;

            // call update or save endpoints
            this.$axios.put(endpoint + "/" + user.id, user) // eslint-disable-next-line
                .then(response => {
                    this.$refs.add_user.clear();
                    this.getItems();
                    this.user = this.$clone(defaults.user_item)
                    this.success("User added to organization.");
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.user_dialog = false;
                });
        },

        openRemoveUser(user) {
            this.user_remove = user;
            this.remove_user_dialog = true;
        },

        removeUser() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/users";

            // orphan user
            this.user_remove.organization_id = null;

            // call update or save endpoints
            this.$axios.put(endpoint + "/" + this.user_remove.id, this.user_remove) // eslint-disable-next-line
                .then(response => {
                    this.getItems();
                    this.success("User kicked.");
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.remove_user_dialog = false;
                });
        },

        // user table functions
        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.page = 1;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.page = 1;
                this.getItems();
            }
        },

        emitClick() {
            this.$emit('click');
        },


    }
}
</script>
<style>
.pointer {
    cursor: pointer;
}
</style>
